import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-policy',
  templateUrl: './redirect-policy.component.html',
  styleUrls: ['./redirect-policy.component.css']
})
export class RedirectPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
